import { IUser } from "../../type/user.type";

export const checkFriend = (userId: string, friends: any) => {
  const userPresent = friends?.filter((friend: any) => friend._id === userId);
  return userPresent?.length >= 1 ? true : false;
};

export const hasSendRequest = (userId: string, friendRequests: any) => {
  const requestSend = friendRequests?.filter(
    (friend: any) => friend.from || friend.to === userId
  );
  return requestSend?.length >= 1 ? true : false;
};
